import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';

export default function UserActivity(props) {
  let activityList;
  if (props.activity) {
    activityList = props.activity.map((item) => {
      if (item.type === 'comment') {
        return (<p key={Math.random()}>
          <strong>Comment</strong> on <NavLink to={`/users/${props.authorID}/posts/${item.postRef}`} >"{item.postName}"</NavLink>:{` ${item.content}`}
        </p>)
      } else if (item.type === "post") return <p key={Math.random()}><strong>Post: </strong><NavLink to={`/users/${props.authorID}/posts/${item.postRef}`} >"{item.postName}"</NavLink></p>
      else if (item.type === "upvote") return <p key={Math.random()}><strong>Upvoted: </strong><NavLink to={`/users/${props.authorID}/posts/${item.postRef}`} >"{item.postName}"</NavLink></p>
    })
  } else activityList = <p>No recent activity.</p>

  return (
    <Row className="mx-0 mt-3">
      <Col xs={12} className="user-activity-card text-left">
        <h5 className="font-weight-bold">Activity</h5>
        {activityList}
      </Col>
    </Row>
  )
}
